import angular from 'angular';
import editCustomersComponent from './editCustomers.component';

let editCustomersModule = angular.module('editCustomers', []).directive('editCustomers', editCustomersComponent);

export default editCustomersModule;



// WEBPACK FOOTER //
// ./app/components/editCustomers/editCustomers.js